import { Card, TableCell } from '@mui/material';
import { styled } from '@mui/system';

export const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: '#FFFFF',
  color: '#333',
  boxShadow: '0px 6px 20px rgba(0, 0, 0, 0.1)',
  borderRadius: '16px',
  transition: 'transform 0.3s, box-shadow 0.3s',
  '&:hover': {
    transform: 'scale(1.05)',
    boxShadow: '0px 8px 30px rgba(0, 0, 0, 0.15)'
  },
  backdropFilter: 'blur(10px)',
  padding: '20px'
}));
export const StyledTableCell = styled(TableCell)({
  fontWeight: 'bold',
  backgroundColor: '#f5f5f5'
});
